import { ReducerBuilder } from './reducerBuilder';
import { LoyaltyTermsAndConditionsMetaDataState } from 'acscp/store';
import { LoyaltyTermsAndConditionsMetaDataRequest } from 'acscp/api/requests/loyaltyTermsAndConditionsMetaDataRequest';
import { LoyaltyTermsAndConditionsMetaData } from 'acscp/api/models/loyaltyTermsAndConditionsMetaData';
import { AcknowledgeLoyaltyTermsAndConditionsRequest } from 'acscp/api/requests';

export const loyaltyTermsAndConditionsMetaDataReducer =
    new ReducerBuilder<LoyaltyTermsAndConditionsMetaDataState>({read: null})
        .successfulRequestCase(
            LoyaltyTermsAndConditionsMetaDataRequest,
            (state, metaData: LoyaltyTermsAndConditionsMetaData) => {
                return {
                    ...state,
                    read: metaData.read
                };
            }
        )
        .successfulRequestCase<undefined, AcknowledgeLoyaltyTermsAndConditionsRequest>(
            AcknowledgeLoyaltyTermsAndConditionsRequest,
            state => {
                return {
                    ...state,
                    read: true
                };
            }
        )
        .build();
